module.exports = __webpack_public_path__ + "static/media/schleudergefahr.a8b21146.svg";